import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "order-basis-modal__container" }
const _hoisted_3 = {
  key: 0,
  class: "non-success"
}
const _hoisted_4 = { class: "non-success__message" }
const _hoisted_5 = {
  key: 1,
  class: "non-success"
}
const _hoisted_6 = { class: "non-success__message" }
const _hoisted_7 = {
  key: 2,
  class: "non-success"
}
const _hoisted_8 = { class: "non-success__message" }
const _hoisted_9 = {
  key: 3,
  class: "order-basis-modal"
}
const _hoisted_10 = { class: "list-view" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "list-view__item-header" }
const _hoisted_13 = { class: "list-view__stat-label" }
const _hoisted_14 = { class: "list-view__updated-at" }
const _hoisted_15 = { class: "list-view__stats" }
const _hoisted_16 = { class: "list-view__stat" }
const _hoisted_17 = { class: "list-view__stat-label" }
const _hoisted_18 = { class: "list-view__stat-value" }
const _hoisted_19 = { class: "list-view__stat" }
const _hoisted_20 = { class: "list-view__stat-label" }
const _hoisted_21 = { class: "list-view__stat-value" }
const _hoisted_22 = {
  key: 0,
  class: "detail-view--unselected"
}
const _hoisted_23 = {
  key: 1,
  class: "detail-view"
}

import { diContainer } from '@/coreContainer/container';
import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { LoadingState } from '@/coreDomainsModule/uiLoadingState';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { LottieAnimation } from 'lottie-web-vue';
import { computed, ref, watch } from 'vue';
import loadingAnimation from '@/assets/loadingAnimation.json';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import OrderBasisDetailSection from './OrderBasisDetailSection.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderBasesModal',
  props: {
    aggregateBusinessId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

const loadingState = ref<LoadingState>({ status: { type: 'none' } });
const orderBases = ref<IOrderBasis[]>([]);
const orderBasisItems = computed(() =>
  orderBases.value.flatMap((basis) =>
    basis.sourceOrderInfos.map((info) => ({ ...info, orderBasisId: basis.orderBasisId, updatedAt: basis.updatedAt }))
  )
);
const selectedSourceOrderId = ref<string>('');

const selectedOrderBasisId = computed(
  () => orderBasisItems.value.find((item) => item.sourceOrderId === selectedSourceOrderId.value)?.orderBasisId
);
const selectedOrderBasis = computed(() => orderBases.value.find((basis) => basis.orderBasisId === selectedOrderBasisId.value));

/**
 * データフェッチ
 */
const fetch = async () => {
  if (!props.aggregateBusinessId) return;
  loadingState.value.status = { type: 'loading' };
  const result = await diContainer.getOrderBasesByAggregateUseCase.execute(props.aggregateBusinessId);
  if (result.status.type === 'error') {
    loadingState.value.status = { type: 'error', errorMessage: 'fetchError' };
    return;
  }
  orderBases.value = result.status.data;
  if (!result.status.data.length) {
    loadingState.value.status = { type: 'zeroMatch' };
    return;
  }
  loadingState.value.status = { type: 'success' };
  return;
};

/**
 * 発注根拠を選択する
 * @param selected - 選択した発注根拠ID
 */
const selectOrderBasis = (selected: string) => {
  selectedSourceOrderId.value = selected;
};

/**
 * 日付を表示用文字列に変換する
 * @param date - ミリ秒UnixTime
 */
const formatDate = (date?: number) => {
  return date ? DateService.convertMSUnixTimeToYYYYMMDDSlash(date) : '--';
};

watch(
  () => props.aggregateBusinessId,
  async (newValue) => {
    selectedSourceOrderId.value = '';
    orderBases.value = [];
    if (!newValue) return;
    await fetch();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": !!props.aggregateBusinessId,
    "modal-width": 1400,
    "enable-outside-click": "",
    "back-button-label": _unref(t)('閉じる'),
    onOnBack: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('発注根拠一覧')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('集計に紐づく発注根拠を確認できます。')), 1),
      (_unref(i18n).locale === 'en')
        ? (_openBlock(), _createElementBlock("br", _hoisted_1))
        : _createCommentVNode("", true),
      _createTextVNode(_toDisplayString(_unref(t)('(表示されているのは根拠作成時の情報です)')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (loadingState.value.status.type === 'loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(LottieAnimation), {
                "animation-data": _unref(loadingAnimation),
                loop: true,
                "auto-play": true
              }, null, 8, ["animation-data"]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('ローディング中...')), 1)
            ]))
          : (loadingState.value.status.type === 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(Mdi, {
                  icon: "error",
                  variant: "outlined",
                  class: "non-success__icon non-success__icon--error"
                }),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('エラーが発生しました')), 1)
              ]))
            : (loadingState.value.status.type === 'zeroMatch')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(Mdi, {
                    icon: "inbox",
                    class: "non-success__icon"
                  }),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('発注根拠がありません')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderBasisItems.value, (basis) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: basis.sourceOrderId,
                        class: _normalizeClass(["list-view__item", { 'list-view__item--selected': selectedOrderBasisId.value === basis.orderBasisId }]),
                        type: "button",
                        onClick: ($event: any) => (selectOrderBasis(basis.sourceOrderId))
                      }, [
                        _createElementVNode("span", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('発注根拠作成日')), 1),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(formatDate(basis.updatedAt)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('発注数量')), 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(basis.initialOrderAmount.addComma()), 1)
                          ]),
                          _createElementVNode("span", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('希望納期')), 1),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(basis.initialDesiredDeliveryDate)), 1)
                          ])
                        ])
                      ], 10, _hoisted_11))
                    }), 128))
                  ]),
                  (!selectedOrderBasisId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(t)('選択してください')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(OrderBasisDetailSection, {
                          "basis-data": selectedOrderBasis.value,
                          "source-order-id": selectedSourceOrderId.value
                        }, null, 8, ["basis-data", "source-order-id"])
                      ]))
                ]))
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label"]))
}
}

})